import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ErrorBoundary } from '@lusha/client-utils';
import { ExperimentsProvider } from '@lusha/experiment-react-sdk';
import { BrazeProvider } from '@lusha/lusha-braze';
import { AnalyticsContextProvider } from '@lusha-engage/analytics';
import { observer } from 'mobx-react';
import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import LushaIntercomProvider from './LushaIntercomProvider';
import config from './config';
import { useMST } from './hooks/MSTHook';
import { useAppDispatch } from './reducers';
import SettingsDispatcher from './reducers/settings/dispatcher';
import { APP_ID } from './utils/constants';
import ErrorScreen from './views/ErrorScreen';
const event_additional_info = {
    plugin_version: config.version,
};
function AppUserContext(props) {
    const { children } = props;
    const { user, userSettings } = useMST(store => ({ user: store.user, userSettings: store.userSettings }));
    const { isPluginOpen } = userSettings;
    const dispatch = useAppDispatch();
    const location = useLocation();
    const isExtensionMode = useMemo(() => {
        /*
         * Indicate that extension is opened in minimal mode (by extension click). (not side bar)
         * maybe there is better way to detect it, but I didn't find
         * */
        return location.pathname === '/toolbar-popup';
    }, []);
    const isFlagsEnabled = !isExtensionMode &&
        // !!isPluginOpen &&  // tmp disabled to test new exclusive flag
        !!(user === null || user === void 0 ? void 0 : user.id);
    useEffect(() => {
        dispatch(SettingsDispatcher.actions.set({
            isExtensionMode,
        }));
    }, [isExtensionMode]);
    return (_jsx(ErrorBoundary, { additionalInfo: { subPlatform: userSettings.platform }, customErrorComponent: _jsx(ErrorScreen, {}), children: _jsx(ExperimentsProvider, { appId: APP_ID, isLoggedIn: isFlagsEnabled, children: _jsx(BrazeProvider, { user: user, children: _jsx(LushaIntercomProvider, { isExtensionMode: isExtensionMode, children: _jsx(AnalyticsContextProvider, { teamName: 'plugin', event_page_state_str: 'plugin', subPlatform: userSettings.platform, event_additional_info: event_additional_info, children: children }) }) }) }) }));
}
export default observer(AppUserContext);
